import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/collectors/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function put(JSONbody, requestOptions) {
  return __request__("PUT", "/collectors/config", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInputIds(requestOptions) {
  return __request__("GET", "/collectors/config/inputs", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createInput(requestOptions) {
  return __request__("POST", "/collectors/config/inputs", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
